<template>
  <div>
    <additional-services-table/>
  </div>
</template>

<script>
import AdditionalServicesTable from "@/components/app/additional-services/AdditionalServicesTable.vue";

export default {
  components: {
    AdditionalServicesTable
  },
  name: "Partners"
}
</script>

<style scoped>

</style>
